import { mapActions } from 'vuex'
import { ORDER_CLEAR, ORDER_DETAILS } from '@/store/types'

export default
{
	props:
	{
		orderId:
		{
			type:     String,
			required: true,
		},
	},

	watch:
	{
		orderId:
		{
			immediate: true,

			handler(orderId)
			{
				return this.loadOrder({ orderId })
			},
		},
	},

	methods:
	{
		...mapActions
		({
			clearOrder: ORDER_CLEAR,
			loadOrder:  ORDER_DETAILS,
		}),
	},

	beforeDestroy()
	{
		this.clearOrder()
	},
}